module.exports = __webpack_public_path__ + "img/cpzz10@2x.f78e02f2.png";